import React from 'react';
import { DropdownBase, TextButton } from '@wix/design-system';
import { ChevronDown, Languages } from '@wix/wix-ui-icons-common';
import { useAppContext } from '../../providers/AppContextProvider';
import { languages } from '../../constants';

const setLanguageUrl = (language, location) => {
  window.location.href = `//manage.wix.com/wix-users/auth/setLanguage?language=${language}&redirectTo=${encodeURIComponent(
    location,
  )}`;
};

export const LanguagePicker: React.FC = () => {
  const {
    appContext: { isEditorX, locale },
  } = useAppContext();

  return (
    <DropdownBase
      dataHook="language-picker"
      options={languages}
      onSelect={(option) => {
        setLanguageUrl(option.id.toString(), window.location.href);
      }}
      initialSelectedId={locale}
      minWidth="SP20"
    >
      {({ toggle, selectedOption = {} }) => {
        return (
          <TextButton
            skin={isEditorX ? 'light' : 'dark'}
            prefixIcon={<Languages />}
            suffixIcon={<ChevronDown />}
            onClick={toggle}
          >
            {selectedOption.value}
          </TextButton>
        );
      }}
    </DropdownBase>
  );
};
